import LockIcon from '@mui/icons-material/Lock'
import { Button } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

const RestrictedAccess = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const cameFromLogin = location.state?.fromLogin === true

    const hasHistory = window.history.length > 2

    const handleNavigation = () => {
        if (cameFromLogin || !hasHistory) {
            navigate('/dashboard')
        } else {
            navigate(-1)
        }
    }
    return (
        <div className="not-found-main">
            <div className="not-found-body">
                <LockIcon className="lock-icon" />
                <p className="access-restricted">Access Restricted</p>
                <p className="access-restricted-body">
                    You don't have permission to visit this link or the link may
                    not be available
                </p>
                <Button
                variant="outlined"
                    onClick={handleNavigation}
                    className='not-found-button'
                    sx={{ textTransform: 'capitalize' }}
                >
                    {cameFromLogin || !hasHistory
                        ? 'Go to Dashboard'
                        : 'Go Back'}
                </Button>
            </div>
        </div>
    )
}

export default RestrictedAccess
